import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica,
} from '../../../../actions/LiquidacionesActions';
import DetalleLiquidacionEditar from './DetalleLiquidacionEditar';
import OrdenesDeLiquidacion from './OrdenesDeLiquidacion';
import NovedadesDeLiquidacion from './NovedadesDeLiquidacion';
import LogisticaDeLiquidacion from './LogisticaDeLiquidacion';
import RebatesDeLiquidacion from "./RebatesDeLiquidacion.js";
import GoBackArrow from '../../../General/GoBackArrow';
import LiquidacionToPDF from "./LiquidacionToPDF.js";
import LiquidacionToExcel from './LiquidacionToExcel.js';
import { getUserTypes } from '../../../../actions/usuariosActions';
import { getLiquidacionPdf, fetchExportarLiquidacionExcelApi, fetchExportarCertificadosPdfApi, fetchExportarCertificadoImpuestosAnexoApi, fetchExportarRetencionesYPercepcionesApi } from '../../../../api/axios.js';
import MiniSpinner from '../../../General/MiniSpinner.js';
import { toast } from 'react-toastify';
import { FileArchive, FileSpreadsheet, FileText, Download } from "lucide-react";

// Wrapper para usar hooks en class component
function EditarLiquidacionWrapper(props) {
    const { id, idSeller } = useParams();
    const location = useLocation();
    return <EditarLiquidacion {...props} id={id} idSeller={idSeller} location={location} />;
}

class EditarLiquidacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liquidacion_por_id: [],
            liquidacion_por_id_novedades: [],
            liquidacion_por_id_ordenes: [],
            liquidacion_por_id_logistica: [],
            request: {
                idLiquidacion: parseInt(this.props.id),
                idSeller: parseInt(this.props.idSeller),
                borrador: 0
            },
            excelDataSet: [],
            isLoading: false,
        }
    };

    componentDidMount() {
        this.props.fetchLiquidacionporid(this.state.request);
        this.props.fetchLiquidacionporidOrdenes(this.state.request);
        this.props.fetchLiquidacionporidNovedades(this.state.request);
        this.props.fetchLiquidacionporidLogistica(this.state.request);
    }

    handleExportPdf = async () => {
        const { liquidacion_por_id } = this.props;

        if (!liquidacion_por_id || !liquidacion_por_id.idLiquidacion) {
            return;
        }

        try {
            const response = await getLiquidacionPdf({ idLiquidacion: liquidacion_por_id.idLiquidacion });

            if (response.data && response.data.pdf) {
                this.descargarPDF(response.data.pdf); // 🔹 Pasar solo el valor de `pdf`
            } else {
                console.error("Error: Respuesta vacía o sin PDF.");
            }

        } catch (err) {
            //console.error("Error al obtener el PDF:", err);
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo");
        }
    };

    async exportarLiquidacionExcel(id, razonSocialSeller) {
        this.setState({ isLoading: true });

        let request = {
            idLiquidacion: id,
        };

        try {
            let res = await fetchExportarLiquidacionExcelApi(request);

            let resBase64 = res.excel;

            if (resBase64) {
                const byteCharacters = atob(resBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                // Formatear nombre del archivo correctamente
                const razonSocialLimpia = razonSocialSeller.replace(/[^a-zA-Z0-9_]/g, "_"); // Reemplaza caracteres especiales
                const fileName = `${razonSocialLimpia}_Liquidacion_N°_${id}.xlsx`;

                // Crear URL y descargar
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                toast.error("Error al generar el archivo.");
            }
        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo");
        } finally {
            this.setState({ isLoading: false });
        }
    }

    async exportarCertificadosPdf(id) {

        let request = {
            idLiquidacion: id,
        };

        try {
            let res = await fetchExportarCertificadosPdfApi(request)

            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                this.descargarZip(base64Zip, "certificadosPdf.zip");
            } else {
                toast.error("No se pudo generar el archivo ZIP.");
            }

        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo .zip");
        }
    }

    async exportarCertificadoImpuestosAnexo(id) {

        let request = {
            idLiquidacion: id,
        };

        try {
            let res = await fetchExportarCertificadoImpuestosAnexoApi(request)

            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                this.descargarZip(base64Zip, "certificadoImpuestosAnexo.zip");
            } else {
                toast.error("No se pudo generar el archivo .zip.");
            }

        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo .zip");
        }
    }

    async exportarRetencionesYPercepciones(id, razonSocial) {
        let request = {
            idLiquidacion: id,
        };

        try {
            let res = await fetchExportarRetencionesYPercepcionesApi(request)

            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                let razonSocialSeller = razonSocial.replace(/[^a-zA-Z0-9]/g, "_");
                let fileName = `retencionesYPercepciones_${razonSocialSeller}.zip`;

                this.descargarZip(base64Zip, fileName);
            } else {
                toast.error("No se pudo generar el archivo .zip.");
            }
        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo .zip");
        }
    }

    descargarZip(base64, fileName) {
        // Convertir Base64 a Blob
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/zip" });

        // Crear URL y descargar
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    descargarPDF = (base64) => {

        const cleanBase64 = base64.replace(/^data:application\/pdf;base64,/, '');

        try {
            const byteCharacters = atob(cleanBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Liquidacion_${new Date().toISOString()}.pdf`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error al convertir Base64 a PDF:", error);
        }
    };

    render() {
        let isSellerAdmin = 3;
        let isSeller = 4;

        return (
            <div className="container">
                <DetalleLiquidacionEditar
                    liquidacion={this.props.liquidacion_por_id}
                    isBorrador={false}
                >
                    {(this.props.tipoUsuario === 8 || this.props.tipoUsuario === 1) && (
                        <div className="card mt-3 border-0 shadow-sm">
                            <div className="card-body p-3">
                                <h6 className="card-subtitle mb-3 text-muted text-uppercase fw-bold" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                                    Datos de Facturación
                                </h6>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>NUMERO DE FACTURA</label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light border-end-0">
                                                <i className="fa fa-hashtag text-muted"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0 ps-0 text-muted"
                                                value={this.props.liquidacion_por_id?.numeroComprobante ?? "-"}
                                                disabled={true}
                                                style={{ backgroundColor: '#fff' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>TIPO DE FACTURA</label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light border-end-0">
                                                <i className="fa fa-file-text-o text-muted"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0 ps-0 text-muted"
                                                value={this.props.liquidacion_por_id?.descripcionTipoFactura ?? this.props.liquidacion_por_id?.idTipoFactura ?? "-"}
                                                disabled={true}
                                                style={{ backgroundColor: '#fff' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>CODIGO SAP</label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light border-end-0">
                                                <i className="fa fa-barcode text-muted"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0 ps-0 text-muted"
                                                value={this.props.liquidacion_por_id?.codigoSap ?? "-"}
                                                disabled={true}
                                                style={{ backgroundColor: '#fff' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </DetalleLiquidacionEditar>

                <div className="d-flex align-items-center my-4 gap-2">

                    <div className="text-center" style={{ cursor: 'pointer' }} title="Volver">
                        <GoBackArrow />
                    </div>

                    <button
                        type="button"
                        title="Exportar a PDF"
                        className="btn btn-sm btn-danger shadow fw-medium d-flex align-items-center justify-content-center"
                        style={{ width: '32px', height: '32px', padding: 0 }}
                        onClick={() => this.handleExportPdf()}
                    >
                        <FileText size={18} />
                    </button>

                    {(this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8) && (
                        <>
                            {this.state.isLoading && <MiniSpinner />}
                            <button
                                title="Exportar a Excel"
                                className="btn btn-sm btn-danger shadow fw-medium d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => this.exportarLiquidacionExcel(this.props.liquidacion_por_id.idLiquidacion, this.props.liquidacion_por_id.razonSocialSeller)}
                                disabled={this.state.isLoading}
                            >
                                <FileSpreadsheet size={18} />
                            </button>

                            <button
                                title="Descargar Certificado Impuestos"
                                onClick={() => this.exportarCertificadoImpuestosAnexo(this.props.liquidacion_por_id.idLiquidacion)}
                                className="btn btn-sm btn-danger shadow fw-medium d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                            >
                                <Download size={18} />
                            </button>

                            <button
                                title="Descargar Retenciones y Percepciones"
                                onClick={() => this.exportarRetencionesYPercepciones(this.props.liquidacion_por_id.idLiquidacion, this.props.liquidacion_por_id.razonSocialSeller)}
                                className="btn btn-sm btn-danger shadow fw-medium d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                            >
                                <Download size={18} />
                            </button>
                        </>
                    )}
                </div>

                <OrdenesDeLiquidacion
                    ordenes={this.props.liquidacion_por_id_ordenes}
                    isLoading={this.props.isLoadingOrdenes}
                />

                <NovedadesDeLiquidacion
                    novedades={this.props.liquidacion_por_id_novedades}
                    isLoading={this.props.isLoadingNovedades}
                />

                <LogisticaDeLiquidacion
                    logistica={this.props.liquidacion_por_id_logistica}
                    isLoading={this.props.isLoadingLogistica}
                />

                <RebatesDeLiquidacion idLiquidacion={this.state.request.idLiquidacion} />
            </div>
        );
    }
}


const mapStateToProps = state => ({
    isLoadingOrdenes: state.liquidaciones.isLoadingOrdenesLiquidacion,
    isLoadingNovedades: state.liquidaciones.isLoadingNovedadesLiquidacion,
    isLoadingLogistica: state.liquidaciones.isLoadingLogisticaLiquidacion,
    liquidacion_por_id: state.liquidaciones.liquidacion_por_id,
    liquidacion_por_id_novedades: state.liquidaciones.liquidacion_por_id_novedades,
    liquidacion_por_id_ordenes: state.liquidaciones.liquidacion_por_id_ordenes,
    liquidacion_por_id_logistica: state.liquidaciones.liquidacion_por_id_logistica,
    tipoUsuario: state.general.tipoUsuario,
    liquidacion_id: state.liquidaciones.liquidacion_por_id.liquidacion,
});

export default connect(mapStateToProps, {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica,
})(EditarLiquidacionWrapper);